module.exports = __webpack_public_path__ + "media/src/images/proctored_icons/no_people_in_room-b51b86a90003408ad564474fd6c74b14.svg";